import { render, staticRenderFns } from "./survey-initial.vue?vue&type=template&id=7b494938&scoped=true"
import script from "./survey-initial.vue?vue&type=script&lang=js"
export * from "./survey-initial.vue?vue&type=script&lang=js"
import style0 from "./survey-initial.vue?vue&type=style&index=0&id=7b494938&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b494938",
  null
  
)

export default component.exports